import {EndGamePlayerState, PlayerColor} from '@colonist/game-states'

export class EndGameStateUtils {
    static getPlayersSortedByRank(players: {[key in PlayerColor]?: EndGamePlayerState}): EndGamePlayerState[] {
        const playersArray = Object.values(players)
        playersArray.sort((a, b) => a.rank - b.rank)
        return playersArray
    }
}
